import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginManager } from '../../../core/login-manager';
import { settings } from '../../../config/settings';
import { ConfirmModal } from '../../../pages/admin/common';
import { iniziali } from '../../../lib/format';
import { isAdmin } from '../../../lib/ruoli';

export default function HeaderBlock({ isLogged, userInfo }) {
    const [currentUser, setCurrentUser] = useState(userInfo);
    const [uscendo, setUscendo] = useState(false);
    const [working, setWorking] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const element = document.getElementById('app-container');
        if (element) element.setAttribute('data-page', location.pathname);
    }, [location]);

    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        setCurrentUser(userInfo || LoginManager.getUserInfo());
    }, [userInfo]);

    /**
     * La conferma sta in un modale e non su una pagina: uscire e' un'azione
     * distruttiva come le altre, e chi ci ripensa deve ritrovarsi dov'era —
     * con una pagina dedicata tornava indietro sempre e solo alla home.
     */
    async function esci() {
        setWorking(true);
        try {
            await LoginManager.logout();
            // `logout` avvisa App, che vedendo la sessione caduta rimanda
            // alla pagina di accesso: qui basta togliersi da quella corrente
            navigate('/', { replace: true });
        }
        finally {
            setWorking(false);
            setUscendo(false);
        }
    }

    const loggedIn = Boolean(isLogged && currentUser);
    const fullName = loggedIn
        ? `${currentUser.name || ''} ${currentUser.surname || ''}`.trim() || currentUser.username
        : '';
    // i PDF stanno in public/manuali: chi amministra ha il suo, che per la
    // parte di prenotazione rimanda a quello del condomino
    const manuale = `${process.env.PUBLIC_URL}/manuali/${isAdmin(currentUser) ? 'manuale-amministratore.pdf' : 'manuale-condomino.pdf'}`;

    return (
        <header className="lv-topbar">
            <div className="lv-topbar-inner">
                <Link to="/" className="lv-brand">
                    <img className="lv-brandmark" src={`${process.env.PUBLIC_URL}/favicon.svg`} alt="" />
                    <div className="lv-brand-text">
                        <h1 className="lv-brand-title">{settings.brand.name}</h1>
                        <p className="lv-brand-sub">{settings.brand.tagline}</p>
                    </div>
                </Link>

                <div className="lv-header-actions">
                    {loggedIn ? (
                        <>
                            <div className="lv-user-chip">
                                <span className="lv-user-initials" aria-hidden="true">{iniziali(fullName)}</span>
                                <span className="lv-user-name">{fullName}</span>
                            </div>
                            {/* Sul telefono resta la sola icona: l'etichetta e' nel nome
                                accessibile, che non dipende dalla larghezza. */}
                            <a
                                href={manuale}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="lv-btn lv-btn-ghost lv-btn-pill lv-guida"
                                aria-label="Guida"
                            >
                                <FontAwesomeIcon icon={['fas', 'circle-question']} />
                                <span className="lv-guida-label">Guida</span>
                            </a>
                            <button
                                type="button"
                                className="lv-btn lv-btn-ghost lv-btn-danger-ghost lv-btn-pill lv-logout"
                                aria-label="Esci"
                                onClick={() => setUscendo(true)}
                            >
                                <FontAwesomeIcon icon={['fas', 'right-from-bracket']} />
                                <span className="lv-logout-label">Esci</span>
                            </button>
                        </>
                    ) : (
                        <Link to="/login" className="lv-btn lv-btn-primary lv-btn-pill">Accedi</Link>
                    )}
                </div>
            </div>

            <ConfirmModal
                show={uscendo}
                title="Uscire dalla piattaforma?"
                message="Dovrai inserire di nuovo email e password al prossimo accesso. Le tue prenotazioni restano dove sono."
                confirmLabel="Esci"
                danger
                working={working}
                onConfirm={esci}
                onClose={() => setUscendo(false)}
            />
        </header>
    );
}
